import * as apiTo from '@/modular-api'
import { getDefaultAddress } from '@/reusable/address-fields/default-address'

const initialState = () => ({
  vendor: null,
  createData: null
})

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    vendor: state => state.vendor,
    mainAddress: state =>
      state.vendor.addresses.find(address => address?.address_type.name === 'main') || getDefaultAddress('main'),
    bankAddress: state =>
      state.vendor.addresses.find(address => address?.address_type.name === 'bank') || getDefaultAddress('bank')
  },

  mutations: {
    setVendor: (state, payload) => (state.vendor = payload),
    setCreateData: (state, payload) => (state.createData = payload),
    updateUncompletedTodos: (state, count) => (state.vendor.incomplete_to_dos_count = count),
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    initData({ commit }, vendorId) {
      return Promise.all([
        apiTo.GET_VENDORS_CREATE(),
        apiTo.GET_VENDOR(vendorId),
        apiTo.GET_VENDOR_CONTACTS(vendorId)
      ]).then(([{ data: createData }, { data: vendor }, { data: contacts }]) => {
        commit('setCreateData', createData.result)
        commit('setVendor', vendor.result)
        commit('provider-show/setContacts', contacts.result, { root: true })
      })
    },

    getAndSetVendor({ commit }, vendorId) {
      return apiTo.GET_VENDOR(vendorId).then(({ data }) => commit('setVendor', data.result))
    },

    updateVendor({ commit, state }, payload) {
      return apiTo.MODIFY_VENDOR(state.vendor.id, payload).then(({ data }) => {
        commit('setVendor', data.result)
        return data.result
      })
    },

    updateField({ commit, dispatch, state }, { set, field, cancel, value, setLoading }) {
      setLoading(true)

      dispatch('updateVendor', { [field]: value || null })
        .then(set)
        .catch(cancel)
        .finally(() => setLoading(false))
    }
  }
}
